import React from "react";

import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  message,
  Modal,
  Row,
  Space,
  Table,
  Tabs,
  Typography,
} from "antd";
import Text from "antd/lib/typography/Text";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import {
  AddReportField,
  companySetting,
  DeleteReportField,
  deleteReportField,
  getReportField,
  updateCompanyReport,
  UpdateCompanyReport,
  UpdateReportField,
  updateReportField,
} from "../../../../actions/companySettings";
import AddNewIcon from "../../../../assets/icons/add_new_white.png";
import DeleteIcon from "../../../../assets/icons/delete.png";
import EditIcon from "../../../../assets/icons/edit.png";
import { hasAccess, objectToFormData } from "../../../../utils";
import PageHeader from "../../../PageHeader";
import "./../../styles/setting.css";
import "./../Custom.css";
import AddReportsField from "./AddReportsField";

const { TabPane } = Tabs;
const { Title } = Typography;

const columns = [
  {
    title: "Field",
    dataIndex: "column_name",
    key: "column_name",
  },
  {
    title: "Column Type",
    dataIndex: "column_type",
    key: "column_type",
  },
];

message.config({
  maxCount: 3,
});

const Reports = () => {
  // const [activeTab, setActiveTab] = React.useState('profile');
  const dispatch = useDispatch();

  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [modalType, setIsModalType] = React.useState("center");
  const [selectedId, setSelectedId] = React.useState("");
  const [reportFields, setReportFields] = React.useState([]);
  const [editMode, setEditMode] = React.useState(false);

  const formik = useFormik({
    initialValues: {},
    onSubmit: (values) => {
      const payload = {};
      [
        "rep_approver_reminder",
        "rep_approver_reminder_days",
        "rep_attach_pdf",
        "rep_comments_pdf",
        "rep_emp_details_pdf",
        "rep_include_logo_pdf",
        "rep_include_receipts_pdf",
        "rep_notify_approver_pdf",
        "rep_report_history_pdf",
        "report_prefix",
        "report_starts_with",
      ].forEach((item) => {
        payload[item] = values[item] || false;
      });
      dispatch(updateCompanyReport(objectToFormData({ ...payload })));
    },
  });

  // const [companyValues, setCompanyValues] = React.useState({});
  const companySettingResponse = useSelector(
    (state) => state.companySetting.companySetting || {},
  );
  const updateCompanySettingResponse = useSelector(
    (state) => state.companySetting.updateCompanySetting || {},
  );
  const reportFieldResponse = useSelector(
    (state) => state.companySetting.getReportField || {},
  );
  const deleteReportFieldResponse = useSelector(
    (state) => state.companySetting.deleteReportField || {},
  );
  const addReportFieldResponse = useSelector(
    (state) => state.companySetting.addReportField || {},
  );
  const updateReportFieldResponse = useSelector(
    (state) => state.companySetting.updateReportField || {},
  );
  const updateCompanyReportResponse = useSelector(
    (state) => state.companySetting.updateCompanyReport || {},
  );
  const { data: { response: { company_setting = {} } = {} } = {} } =
    companySettingResponse;
  const setTab = () => {};

  React.useEffect(() => {
    dispatch(companySetting({}));
    dispatch(getReportField({}));
    // setIsModalVisible(false,);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    formik.resetForm();
    const { data: { response: { company_setting = {} } = {} } = {} } =
      companySettingResponse;
    // setCompanyValues({...company_setting});
    formik.setValues({
      rep_approver_reminder: company_setting.rep_approver_reminder,
      rep_approver_reminder_days: company_setting.rep_approver_reminder_days,
      rep_attach_pdf: company_setting.rep_attach_pdf,
      rep_comments_pdf: company_setting.rep_comments_pdf,
      rep_emp_details_pdf: company_setting.rep_emp_details_pdf,
      rep_include_logo_pdf: company_setting.rep_include_logo_pdf,
      rep_include_receipts_pdf: company_setting.rep_include_receipts_pdf,
      rep_notify_approver_pdf: company_setting.rep_notify_approver_pdf,
      rep_report_history_pdf: company_setting.rep_report_history_pdf,
      report_prefix: company_setting.report_prefix,
      report_starts_with: company_setting.report_starts_with,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companySettingResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = false } = {} } =
      updateCompanyReportResponse;
    if (status) {
      dispatch(companySetting({}));
      handleSubmit();
      dispatch({
        type: UpdateCompanyReport.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateCompanyReportResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = updateCompanySettingResponse;
    if (status) {
      dispatch({
        type: UpdateCompanyReport.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: UpdateCompanyReport.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateCompanySettingResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = updateReportFieldResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getReportField({}));
      dispatch({
        type: UpdateReportField.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: UpdateReportField.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateReportFieldResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = deleteReportFieldResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getReportField({}));
      dispatch({
        type: DeleteReportField.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: DeleteReportField.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteReportFieldResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = addReportFieldResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getReportField({}));
      dispatch({
        type: AddReportField.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: AddReportField.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addReportFieldResponse]);

  React.useEffect(() => {
    const { data: { response: { fields = [] } = {}, status = false } = {} } =
      reportFieldResponse;
    if (status) {
      setReportFields(fields);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportFieldResponse]);

  const tableAction = [
    {
      title: "Mandatory",
      dataIndex: "is_required",
      key: "is_required",
      render: (status, record) => (
        <Checkbox
          key={record.id}
          disabled={!hasAccess("reports_settings", "write")}
          onChange={(e) =>
            dispatch(
              updateReportField(
                objectToFormData({
                  ...record,
                  is_required: e.target.checked,
                }),
              ),
            )
          }
          checked={status}
        ></Checkbox>
      ),
    },
    // {
    //   title: "Show in PDF",
    //   dataIndex: "view_in_pdf",
    //   key: "view_in_pdf",
    //   render: (status, record) => (
    //     <Checkbox
    //       disabled={!hasAccess("reports_settings", "write")}
    //       key={record.id}
    //       onChange={(e) => dispatch(updateReportField(objectToFormData({ ...record, view_in_pdf: e.target.checked, })))}
    //       checked={status}
    //     ></Checkbox>
    //   ),
    // },
    {
      title: "Enable",
      dataIndex: "is_enable",
      key: "is_enable",
      render: (status, record) => (
        <Checkbox
          disabled={!hasAccess("reports_settings", "write")}
          key={record.id}
          onChange={(e) =>
            dispatch(
              updateReportField(
                objectToFormData({ ...record, is_enable: e.target.checked }),
              ),
            )
          }
          checked={status}
        ></Checkbox>
      ),
    },
    {
      title: "Actions",
      key: "action",
      render: (text, record) => (
        <Space key={record.id} size="middle">
          <button
            disabled={!hasAccess("reports_settings", "write")}
            onClick={() => showEditModal(record.id)}
          >
            <img src={EditIcon} alt={"logo"} className="action-logo" />
          </button>
          <button
            disabled={!hasAccess("reports_settings", "write")}
            onClick={() => showDeleteModal(record.id)}
          >
            <img src={DeleteIcon} alt={"logo"} className="action-logo" />
          </button>
        </Space>
      ),
    },
  ];

  const handleEdit = () => {
    setEditMode(true);
  };

  const handleSubmit = () => {
    setEditMode(false);
  };

  const showModal = () => {
    setSelectedId("");
    setIsModalVisible(true);
    setIsModalType("right");
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const showDeleteModal = (id) => {
    setSelectedId(id);
    setIsModalVisible(true);
    setIsModalType("center");
  };

  const showEditModal = (id) => {
    setSelectedId(id);
    setIsModalVisible(true);
    setIsModalType("right");
  };

  const renderDeleteOption = () => {
    return (
      <>
        <Text>Are you sure you want to delete this field?</Text>
        <br />
        <Button
          key="1"
          className="formButton mt1"
          onClick={() =>
            dispatch(deleteReportField(objectToFormData({ id: selectedId })))
          }
        >
          Delete
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt1"
          onClick={() => handleCancel()}
        >
          Cancel
        </Button>
      </>
    );
  };

  return (
    <>
      {isModalVisible && (
        <Modal
          title={
            modalType === "center" ? (
              <>
                <img src={DeleteIcon} alt={"logo"} className="action-logo" />{" "}
                Delete Field
              </>
            ) : (
              <Title level={4}>
                {selectedId ? "Edit Fields" : "Add Fields"} &nbsp;
                <span className="text-small">Enter details and submit</span>
              </Title>
            )
          }
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={[]}
          className={
            modalType === "center"
              ? "center-aligned-modal"
              : "right-alinged-modal-small"
          }
        >
          {modalType === "center" ? (
            renderDeleteOption()
          ) : (
            <AddReportsField id={selectedId} handleCancel={handleCancel} />
          )}
        </Modal>
      )}
      <div className="heading-div">
        <PageHeader
          title={`Reports`}
          navigation={{
            Home: "/dashboard/",

            Customisation: "/setting/customisation/",
            Reports: null,
          }}
        />
      </div>
      <Tabs onChange={setTab} type="card" size="large" className="custom-tabs">
        <TabPane tab="Preferences" key="preferences">
          <div className="tabContentWrapper">
            <Title level={5}>Auto-generate Report ID</Title>
            <Divider />
            <Form
              layout="vertical"
              className="custom-form"
              onFinish={formik.handleSubmit}
              // validateMessages={validateMessages1}
            >
              <Row>
                <Col span={8}>
                  <Form.Item label="Prefix">
                    <Input
                      name="report_prefix"
                      onChange={formik.handleChange}
                      value={formik.values.report_prefix}
                      placeholder=""
                      disabled={!editMode || company_setting.report_prefix}
                      //disabled={company_setting.report_prefix}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} className="ml1">
                  <Form.Item label="Start with">
                    <Input
                      name="report_starts_with"
                      //onChange={formik.handleChange}
                      onChange={(e) => {
                        if (Number.isNaN(Number(e.target.value))) {
                          return;
                        }
                        formik.setFieldValue(
                          "report_starts_with",
                          e.target.value,
                        );
                      }}
                      placeholder=""
                      value={formik.values.report_starts_with}
                      disabled={!editMode || company_setting.report_starts_with}
                    />
                  </Form.Item>
                </Col>
              </Row>
              {/* <Title level={5} className="customTitle">
                PDF Options
              </Title>
              <Divider />
              <Row>
                <Col span={24}>
                  <Form.Item name="rep_emp_details_pdf" valuePropName="checked">
                    <Checkbox>Show Employee Details in PDF</Checkbox>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="rep_report_history_pdf"
                    valuePropName="checked"
                  >
                    <Checkbox>Show Report History in PDF</Checkbox>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item name="rep_comments_pdf" valuePropName="checked">
                    <Checkbox>Show Report Comments in PDF</Checkbox>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="rep_include_receipts_pdf"
                    valuePropName="checked"
                  >
                    <Checkbox>Include receipts/bills in report PDF</Checkbox>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="rep_include_logo_pdf"
                    valuePropName="checked"
                  >
                    <Checkbox>Include company logo in report PDF</Checkbox>
                  </Form.Item>
                </Col>
              </Row> */}

              {/*  <Title level={5} className="customTitle">
                On expense report submission
              </Title>
              <Divider />
              <Row>
                <Col span={24}>
                  <Form.Item
                    valuePropName="checked"
                  >
                    <Checkbox
                      disabled={!editMode}
                      onChange={(e) => {
                        if (Number.isNaN(Number(e.target.value))) {
                          return;
                        }
                        formik.setFieldValue("report_approval_on_email", e.target.value)
                      }}
                      value={formik.values.report_approval_on_email}
                    >
                      Notify approver via email when reports are submitted
                    </Checkbox>
                  </Form.Item>
                </Col>
                 <Col span={24}>
                  <Form.Item name="rep_attach_pdf" valuePropName="checked">
                    <Checkbox>
                      Attach report as a PDF file to the notification email
                    </Checkbox>
                  </Form.Item>
                </Col> 
              </Row>*/}

              <Title level={5} className="customTitle">
                Approval Notifications
              </Title>
              <Divider />
              <Row>
                <Col span={24}>
                  <Form.Item
                    valuePropName="checked"
                    style={{ marginBottom: "0px" }}
                  >
                    <Checkbox
                      checked={formik.values.rep_approver_reminder}
                      name="rep_approver_reminder"
                      disabled={!editMode}
                      onChange={(e) => {
                        formik.setFieldValue(
                          "rep_approver_reminder",
                          e.target.checked,
                        );
                      }}
                    >
                      <span className="flexDisplay">
                        Reminder alert to approvers if the expense reports are
                        pending for more than &nbsp;
                        <Form.Item className="shortNumberInput">
                          <Input
                            className="shortInput"
                            name="rep_approver_reminder_days"
                            disabled={!editMode}
                            onChange={(e) => {
                              if (Number.isNaN(Number(e.target.value))) {
                                return;
                              }
                              formik.setFieldValue(
                                "rep_approver_reminder_days",
                                e.target.value,
                              );
                            }}
                            value={formik.values.rep_approver_reminder_days}
                          />
                        </Form.Item>{" "}
                        &nbsp;days
                      </span>
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>
              {!editMode && hasAccess("reports_settings", "write") && (
                <Button
                  type="button"
                  className="formButton mt3"
                  onClick={() => handleEdit()}
                >
                  Edit
                </Button>
              )}
              {editMode && (
                <Button
                  key="5"
                  className="formButton mt3"
                  htmlType="submit"
                  disabled={updateCompanyReportResponse?.loading}
                >
                  Save
                </Button>
              )}
              {/* <Button key="6" className="cancelButton ml1 mt3" onClick={() => history.push(RouteConstants.SETTING_USERS)}></Button> */}
            </Form>
          </div>
        </TabPane>
        <TabPane tab="Fields" key="fields">
          <div className="tabContentWrapper">
            {hasAccess("reports_settings", "write") && (
              <Button onClick={showModal} className="mb1 addNew">
                <img src={AddNewIcon} alt={"logo"} className="addNew-logo" />{" "}
                New Field
              </Button>
            )}
            <Table
              rowKey="id"
              columns={[...columns, ...tableAction]}
              dataSource={reportFields}
              className="settingsTable"
            />
          </div>
        </TabPane>
      </Tabs>
    </>
  );
};

export default Reports;
